import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tradeDescriptionData: {
    supplierName: '',
    supplierCountry: '',
    supplierWebsite: '',
    supplierDescription: '',
    supplierLogo: null,
    buyerName: '',
    buyerCountry: '',
    buyerWebsite: '',
    buyerDescription: '',
    buyerLogo: null,
    industry: '',
    goodsAndServices: '',
    description: '',
    creditLimitRequested: '',
    financingPercentage: '90',
    financingPeriod: '',
    financingType: 'Receivable Financing',
    recourseType: 'Non Recourse',
    insurance: 'Insured',
    annualTurnover: '',
    currency: 'USD',
  },
  editStatus: 'Pre-Filled', // Initialiser `editStatus` avec "Pre-Filled"
  status: 'idle', // idle | saving | saved
};

const tradeDescriptionSlice = createSlice({
  name: 'tradeDescription',
  initialState,
  reducers: {
    saveTradeDescriptionData: (state, action) => {
      state.tradeDescriptionData = action.payload;
      state.status = 'saved';
    },
    updateTradeDescriptionField: (state, action) => {
      const { field, value } = action.payload;
      state.tradeDescriptionData[field] = value;
    },
    setEditStatus: (state, action) => {
      state.editStatus = action.payload;
    },
    setSavingStatus: (state, action) => {
      state.status = action.payload;
    },
    resetStatus: (state) => {
      state.status = 'idle';
    }
  },
});

export const { 
  saveTradeDescriptionData, 
  updateTradeDescriptionField, 
  setEditStatus, 
  setSavingStatus, 
  resetStatus 
} = tradeDescriptionSlice.actions;

export default tradeDescriptionSlice.reducer;
